
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      isChecked: false,
      settings: {
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      },
      mainOptions: [
        {
          name: "checked",
          label: "S plavom pozadinom",
          type: "checkbox",
        },
      ],
      options: [
        {
          name: "image",
          label: "Slika",
          type: "image",
        },

        {
          name: "text",
          label: "Tekst",
          type: "tipTap",
        },
        {
          name: "client",
          label: "Klijent",
          type: "text",
        },
        {
          name: "position",
          label: "Pozicija",
          type: "text",
        },
      ],
    };
  },
  computed: {
    isHomepage: function () {
      if (this.isChecked) {
        this.isChecked = this.$refs.mainList.items[0].checked;
        return this.isChecked;
      } else return false;
    },
  },
  mounted() {
    if (
      this.$refs.mainList &&
      this.$refs.mainList.items[0] &&
      this.$refs.mainList.items[0].checked
    ) {
      this.isChecked = this.$refs.mainList.items[0].checked;
    }
  },
};
